import { Bill } from '@mews-commander/data-access';
import { Body, Icon, Stack, Typography } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { ModalLink } from '../../../../../components';
import { useGetInfoRowProps } from './utils';

interface Props {
    bill: Bill;
}

export const AssociatedWithInfo = ({ bill }: Props) => {
    const { iconValue, url, name } = useGetInfoRowProps({ accountId: bill.associatedAccountId });

    return (
        <Stack itemAlignment="center">
            <Typography textStyle="bodySmallStrong" variant="secondary" as="div">
                <LocalizedText textKey={TextKey.BillAssociatedWith} />
            </Typography>
            {UnicodeEntity.NoBreakSpace}
            {iconValue && (
                <>
                    <Icon size="small" value={iconValue} />
                    {UnicodeEntity.NoBreakSpace}
                </>
            )}
            <Body size="small">
                {url && name ? (
                    <ModalLink url={url}>{name}</ModalLink>
                ) : (
                    <LocalizedText textKey={TextKey.BillingNoAssociatedProfiles} />
                )}
            </Body>
        </Stack>
    );
};
